<template>
  <div class="d-flex align-items-center border-top" :class="showOnlyNextButton ? 'justify-content-end' : 'justify-content-between'">
    <b-button v-if="canGoBack" variant="secondary" @click="handleBack">
      <font-awesome-icon :icon="['fal', 'chevron-left']" class="mr-2" />
      {{ backButtonText }}
    </b-button>
    <b-button v-if="canCancel" variant="outline-secondary" @click="handleCancel">
      <font-awesome-icon :icon="['fal', 'chevron-left']" class="mr-2" />
      {{ cancelLabel || $t('Webportal.Cancel') }}
    </b-button>

    <b-button v-if="showSaveDraft" variant="outline-primary" :disabled="isSavingDraft" @click="handleSaveDraft">
      <b-spinner v-if="isSavingDraft" small class="mr-2" />
      <font-awesome-icon v-else :icon="['fal', 'save']" class="mr-2" />
      {{ $t('Webportal.Actions.InquiryWizard.Draft.SaveButton') }}
    </b-button>

    <b-button :variant="isLastStep ? 'danger' : 'primary'" :disabled="!canGoNext" @click="handleNext">
      {{ nextButtonText }}
      <font-awesome-icon v-if="!isLastStep" :icon="['fal', 'chevron-right']" class="ml-2" />
    </b-button>
  </div>
</template>

<script>
export default {
  name: "WizardNavigation",

  props: {
    canGoBack: {
      type: Boolean,
      default: false,
    },
    canCancel: {
      type: Boolean,
      default: false,
    },
    canGoNext: {
      type: Boolean,
      default: true,
    },
    cancelLabel: {
      type: String,
      default: null,
    },
    isLastStep: {
      type: Boolean,
      default: false,
    },
    showSaveDraft: {
      type: Boolean,
      default: false,
    },
    isSavingDraft: {
      type: Boolean,
      default: false,
    },
    currentStep: {
      type: Number,
      default: 1,
    },
    backButtonLabel: {
      type: String,
      default: null,
    },
    nextButtonLabel: {
      type: String,
      default: null,
    },
  },

  computed: {
    showOnlyNextButton() {
      return !this.canGoBack && !this.canCancel;
    },

    backButtonText() {
      return this.backButtonLabel || this.$t('Webportal.Back');
    },

    nextButtonText() {
      if (this.nextButtonLabel) {
        return this.nextButtonLabel;
      }
      if (this.isLastStep) {
        return this.$t('Webportal.Actions.InquiryWizard.Navigation.Submit');
      }
      return this.$t('Webportal.Continue');
    },
  },

  methods: {
    handleBack() {
      this.$emit("back");
    },

    handleNext() {
      this.$emit("next");
    },

    handleSaveDraft() {
      this.$emit('save-draft');
    },

    handleCancel() {
      this.$router.push({ name: "InquiryLanding" });
    },
  },
};
</script>

<style lang="scss" scoped>
// All styling comes from Bootstrap
</style>
